import { useEffect } from "react";

import type { IUseGlobalSearchFocusGuardProps } from "../types";

const DIALOG_SELECTOR = '[role="dialog"]';
const INPUT_SELECTOR = "[cmdk-input]";

// NOTE: NSAI-6853 — the palette is modal, yet focus can still be moved behind
// it by code: the chat page focuses its composer on a timer once it mounts
// and again when it picks the default model, which lands after the palette
// has opened on a slow load. The keys typed next then go to the page and the
// tabs and the highlight stop answering. Focus moved outside the palette by
// anything but the palette itself is sent back to the search box. A press
// outside closes the dialog first, so the user's own clicks never reach here.
export const useGlobalSearchFocusGuard = ({
  rootRef,
}: IUseGlobalSearchFocusGuardProps): void => {
  useEffect(() => {
    const handleFocusIn = (event: FocusEvent): void => {
      const dialog = rootRef.current?.closest(DIALOG_SELECTOR);
      const { target } = event;
      if (!dialog || !(target instanceof Node) || dialog.contains(target)) {
        return;
      }
      // NOTE: Another dialog opened on top (a confirmation) owns its focus.
      if (target instanceof Element && target.closest(DIALOG_SELECTOR)) return;
      dialog.querySelector<HTMLElement>(INPUT_SELECTOR)?.focus();
    };

    document.addEventListener("focusin", handleFocusIn);
    return () => {
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, [rootRef]);
};
